// Smart Wishlist only draws its heart on page load. Product cards inserted later
// (filters, sorting, load more, infinite scroll) arrive as empty markers, so ask the
// app to redraw once for each new batch of markers in the collection grid.
(() => {
  if (window.collectionWishlistObserver) return;

  const MARKER = '.card-product__wishlist';
  const NEW_MARKER = `${MARKER}:not([data-wishlist-requested])`;
  // Batches the burst of DOM mutations from a single grid render into one redraw.
  const REDRAW_DELAY_MS = 100;
  let scheduled = false;

  // The app's styled tooltip is off on collection pages, so the browser would show
  // its raw HTML title text. Drop it; the app's aria-label still names the button.
  const stripTitle = (marker) => {
    if (marker.hasAttribute('title')) marker.removeAttribute('title');
  };

  const redraw = () => {
    scheduled = false;
    if (typeof window.ReloadSmartWishlist !== 'function') return;

    const markers = document.querySelectorAll(NEW_MARKER);
    if (!markers.length) return;

    // Flag first so a marker the app leaves empty never triggers a reload loop.
    markers.forEach((marker) => marker.setAttribute('data-wishlist-requested', ''));
    window.ReloadSmartWishlist();
  };

  // Markers rendered with the page are drawn by the app's own startup.
  document.querySelectorAll(MARKER).forEach((marker) => {
    marker.setAttribute('data-wishlist-requested', '');
    stripTitle(marker);
  });

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.target.matches(MARKER)) {
        stripTitle(mutation.target);
      }
    });

    if (scheduled) return;
    scheduled = true;
    setTimeout(redraw, REDRAW_DELAY_MS);
  });

  // The app sometimes leaves a marker empty (slow load, a grid rendered before it
  // was ready). Retry those a few times so every card ends up with its heart.
  const RETRY_DELAYS_MS = [1500, 4000, 9000];
  const retryEmpty = (attempt) => {
    if (attempt >= RETRY_DELAYS_MS.length) return;
    setTimeout(() => {
      const empty = document.querySelectorAll(`${MARKER}:empty`);
      if (empty.length && typeof window.ReloadSmartWishlist === 'function') {
        empty.forEach((marker) => marker.setAttribute('data-wishlist-requested', ''));
        window.ReloadSmartWishlist();
      }
      retryEmpty(attempt + 1);
    }, RETRY_DELAYS_MS[attempt]);
  };
  retryEmpty(0);

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['title'],
  });
  window.collectionWishlistObserver = observer;
})();
